"use strict";
exports.__esModule = true;
exports.newAnalyticsEventFactory = exports.newAnalyticsEventWithPropertiesFactory = exports.newAnalyticsEventWithOptionalPropertiesFactory = void 0;
var newAnalyticsEventWithOptionalPropertiesFactory = function (eventName) {
    return function (eventProperties) { return ({
        event: eventName,
        properties: (eventProperties || {})
    }); };
};
exports.newAnalyticsEventWithOptionalPropertiesFactory = newAnalyticsEventWithOptionalPropertiesFactory;
var newAnalyticsEventWithPropertiesFactory = function (eventName) {
    return function (eventProperties) { return ({
        event: eventName,
        properties: eventProperties
    }); };
};
exports.newAnalyticsEventWithPropertiesFactory = newAnalyticsEventWithPropertiesFactory;
var newAnalyticsEventFactory = function (eventName) {
    return function () { return ({
        event: eventName
    }); };
};
exports.newAnalyticsEventFactory = newAnalyticsEventFactory;
